import { render, staticRenderFns } from "./ElevatedBtn.vue?vue&type=template&id=9d008fee"
import script from "./ElevatedBtn.vue?vue&type=script&lang=ts"
export * from "./ElevatedBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports